import io from 'socket.io-client'

// Flag para deshabilitar la conexión automática del socket (p. ej. en desarrollo).
// Se activa con VUE_APP_DISABLE_SOCKET=true (ver .env.development). Cuando está
// activo, el socket no se conecta solo: hay que hacerlo manualmente desde el
// panel de logs (LogsTab).
export const socketAutoConnectDisabled = process.env.VUE_APP_DISABLE_SOCKET === 'true'

// URL por defecto del servidor de socket. Se puede sobreescribir desde la
// configuración de la app (ConfigDialog), que la guarda en data.json. Aquí, en
// el import, se lee de forma síncrona vía IPC (loadConfigSync) con fallback al
// default. El cambio se aplica al reiniciar la aplicación.
export const DEFAULT_SOCKET_URL = 'https://socket.estudio.admira.com/ECI_ESTUDIO'

function getSocketUrl() {
  try {
    const config = window.ipcRenderer.loadConfigSync()
    const url = config && config.socketUrl
    return url && url.trim() !== '' ? url.trim() : DEFAULT_SOCKET_URL
  } catch (e) {
    return DEFAULT_SOCKET_URL
  }
}

const socket = io(getSocketUrl(), {
  autoConnect: false,
  transports: ['websocket'],
  secure: true,
  timeout: 20000,
  reconnection: true,
  reconnectionDelay: 2000,
  reconnectionDelayMax: 5000,
  reconnectionAttempts: 20
});

export default socket

